<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-4">
            <h4 class="text-7">Biller</h4>
            <router-link
                :to="`/business/payments/create`"
                class="btn btn-primary btn-sm text-white shadow-none ml-auto"
                v-if="stage === 7 && hasPermission(permissions, 'create-billers')"
            >
                <i class="fas fa-plus-circle mr-2"></i>Create Profile
            </router-link>
        </div>
        <!-- Only show banners if the event is not live -->
        <div class="mb-3" v-if="!allRequirementsCompleted">
            <!-- Upload Documents Banner - only show if documents are missing -->
            <div class="notification notice">
                <p class="notice-text">
                    Identity Documents and Bank Details are required to start receiving payments.
                </p>
                <ul class="requirements-list">
                    <li @click="navigateTo('banking-details')">
                <span class="requirement-status">
                    <i :class="requirements.banks.completed ? 'fas fa-check check-icon' : 'fas fa-times cross-icon'"></i>
                </span>
                        <span class="requirement-label">Bank Details</span>
                    </li>
                    <li @click="navigateTo('business-documents')">
                <span class="requirement-status">
                    <i :class="requirements.documents.completed ? 'fas fa-check check-icon' : 'fas fa-times cross-icon'"></i>
                </span>
                        <span class="requirement-label">Business Documents</span>
                    </li>
                    <li @click="navigateTo('authorized-individuals')">
                <span class="requirement-status">
                    <i :class="requirements.authorised_individuals.completed ? 'fas fa-check check-icon' : 'fas fa-times cross-icon'"></i>
                </span>
                        <span class="requirement-label">Authorized Individuals</span>
                    </li>
                </ul>
                <!-- Payment Methods -->
                <div class="payment-section">
                    <p class="payment-title">Accept all major credit cards</p>
                    <div class="payment-logos">
                        <img src="/images/payment/mastercard.png" alt="Mastercard" />
                        <img src="/images/payment/visa.png" alt="Visa" />
                    </div>
                </div>
                <div class="payment-section">
                    <p class="payment-title">Accept Ecocash Payments</p>
                    <div class="payment-logos">
                        <img src="/img/EcoCash.svg" alt="EcoCash" class="ecoCash-logo" />
                    </div>
                </div>
                <!-- Upload Button -->
                <div class="button-container mt-3">
                    <router-link
                        to="/business/settings/banking-details"
                        class="btn btn-sm btn-success text-white shadow-none"
                    >
                        <i class="fas fa-upload mr-2"></i> Upload Documents and Bank Details
                    </router-link>
                </div>
            </div>

            <!-- Approval Banner - only show if awaiting approval or approved -->

        </div>
        <div class="bg-white rounded shadow-sm p-4">

            <div class="table-responsive">

                <div v-if="data && data.content && data.content.data && data.content.data.length && hasPermission(permissions, 'manage-billers')">
                    <h4 class="text-4 mb-3" >Biller Profiles</h4>
                    <table class="table table-hover d-none d-md-block align-center-table">
                        <thead>
                        <tr>
                            <th style="width: 40%;">Name</th>
                            <th style="width: 10%;">Status</th>
                            <th  style="width: 50%;" class="text-right"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="row in data.content.data">
                            <td>{{ row.name }}</td>
                            <td>{{ row.status === 'ACTIVE' ? 'PUBLIC' : row.status }}</td>
                            <td v-if="row.status === 'ACTIVE' || row.status === 'PRIVATE' || row.status === 'PUBLIC'" class="text-right">
                                <button
                                    class="btn btn-outline-primary btn-sm shadow-none"
                                    @click="generateAndDownloadQR(row)"
                                    title="Generate QR Code"
                                >
                                    <i class="fas fa-qrcode"></i> QR
                                </button>
                                <button
                                    class="btn btn-outline-primary btn-sm shadow-none"
                                    @click="copyLink(generateLink(row))"
                                    title="Copy Link"
                                >
                                    <i class="fas fa-link"></i>
                                </button>
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/profile`">
                                    <strong>Profile</strong>
                                </router-link>
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/view`">
                                    <strong>Payments</strong>
                                </router-link>
                            </td>
                            <td v-else-if="row.status === 'AWAITING-APPROVAL' " class="text-right">
                                <button
                                    class="btn btn-outline-primary btn-sm shadow-none"
                                    @click="previewLink(row)"
                                    title="Preview Link"
                                >
                                    Preview <i class="fas fa-link"></i>
                                </button>
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/profile`">
                                    <strong>Profile</strong>
                                </router-link>
                            </td>
                            <td v-else class="text-right">
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/become-biller`"><strong>Complete Registration</strong>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-for="row in data.content.data" class="row d-block d-md-none border-top border-bottom py-2">
                        <div class="col-12">
                            <p class="text-2 mb-0">Name: <b>{{ row.name }}</b></p>
                        </div>
                        <div class="col-12 mb-1">
                            <p class="text-2 mb-0">Status: <b>{{ row.status }}</b></p>
                        </div>
                        <div class="col-12">
                            <div v-if="row.status === 'ACTIVE' || row.status === 'PRIVATE'" class="mb-2">
                                <button
                                    class="btn btn-outline-primary btn-sm shadow-none"
                                    @click="generateAndDownloadQR(row)"
                                    title="Generate QR Code"
                                >
                                    <i class="fas fa-qrcode"></i> QR
                                </button>
                                <button
                                    class="btn btn-outline-primary btn-sm shadow-none"
                                    @click="copyLink(generateLink(row))"
                                    title="Copy Link"
                                >
                                    <i class="fas fa-link"></i>
                                </button>
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/profile`">
                                    <strong>Profile</strong>
                                </router-link>
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/view`">
                                    <strong>Payments</strong>
                                </router-link>
                            </div>
                            <div v-else-if="row.status === 'AWAITING-APPROVAL' " class="mb-2">
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/payments/${row.id}/profile`">
                                    <strong>Profile</strong>
                                </router-link>
                            </div>
                            <div v-else class="mb-2">
                                <router-link class="btn btn-outline-primary btn-sm shadow-none" :to="`/business/become-biller`"><strong>Complete Registration</strong>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="hasPermission(permissions, 'create-billers')">
                    <div class="col-sm-12 col-md-12">
                        <router-link
                            :to="`/business/become-biller`"
                        >
                            <div class="hover-border hover-section shadow-sm rounded text-center px-3 py-4">
                        <span class="d-block text-10 text-light mt-2 mb-3">
                            <i class="fas fa-hand-holding-usd service-icon"></i>
                        </span>
                                <p class="mb-0 text-3 service-text"><b>Create a Biller Account</b></p>
                                <small class="service-text-small">Receive payments as a biller on Magetsi</small>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div v-else>
                    <div class="col-sm-12 col-md-12">
                        <div>
                            <div class="hover-border hover-section shadow-sm rounded text-center px-3 py-4">
                                <span class="d-block text-10 text-light mt-2 mb-3">
                                    <i class="fas fa-ban service-icon"></i>
                                </span>
                                <p class="mb-0 text-3 service-text"><b>You do not have sufficient rights to access this feature</b></p>
                                <small class="service-text-small">Contact your Admin for assistance</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Toast Notification -->
        <div v-if="showToast" class="toast-notification">
            {{ toastMessage }}
        </div>
    </div>
</template>

<script>
import Data from "../../../../core/data/Data";
import {urlEncoder} from "../../../../core/utils/url";
import QRCode from "qrcode";

export default {
    name: "Index",
    props: ['permissions'],
    mixins: [urlEncoder],
    data() {
        return {
            stage:0,
            showToast: false,
            toastMessage: "",
            data: new Data({
                url: "/business/payments/list",
                prefix: "list"
            }),
            requirements: {
                documents: { count: 0, required: 4, completed: false },
                banks: { count: 0, required: 1, completed: false },
                authorised_individuals: { count: 0, required: 1, completed: false }
            },
            allRequirementsCompleted: false
        };
    },
    mounted() {
        this.data.fetch();
        this.setStage();
        this.checkRequirements();
    },
    methods: {
        showToastMessage(message) {
            this.toastMessage = message;
            this.showToast = true;
            setTimeout(() => {
                this.showToast = false;
            }, 2000);
        },
        generateLink(row) {
            const baseURL = typeof window !== 'undefined' ? window.location.origin : '';
            return `${baseURL}/billers/pay/${this.encode(row.id)}/${row.name.toLowerCase().replace(/ /g, '-').replace(/\//g, '')}`;
        },
        async generateAndDownloadQR(row) {
            try {
                const qrData = await QRCode.toDataURL(this.generateLink(row));
                const link = document.createElement("a");
                link.href = qrData;
                link.download = `qr_code_${new Date().toISOString().slice(0, 19)}.png`;
                link.click();
            } catch (error) {
                console.error("Error generating QR code:", error);
            }
        },
        copyLink(link) {
            navigator.clipboard.writeText(link)
                .then(() => {
                    this.showToastMessage("Link copied to clipboard!");
                })
                .catch(() => {
                    this.showToastMessage("Failed to copy link.");
                });
        },
        async setStage() {
            try {
                const response = await axios.get('/business/biller-onboarding/check-stage');
                const { body } = response.data;
                this.stage = body.status;
            } catch (error) {
                console.error("Error fetching biller status:", error);
                this.stage = 1;
            }
        },
        async checkRequirements() {
            try {
                const response = await axios.get('/business/biller-onboarding/check-requirements');
                const { requirements, all_completed } = response.data.body;
                this.requirements = requirements;
                this.allRequirementsCompleted = all_completed;
            } catch (error) {
                console.error("Error checking requirements:", error);
            }
        },
        navigateTo(route) {
            this.$router.push(`/business/settings/${route}`);
        },
        previewLink(row) {
            const link = this.generateLink(row);
            window.open(link, '_blank');
        }
    }
}
</script>

<style scoped>
    .align-center-table td {
        vertical-align: middle;
    }
    .hover-border {
        border: 1px solid #ddd;
        transition: border-color 0.3s ease;
    }
    .hover-border:hover {
        border-color: #28a745;
    }
    .service-text{
        color: #212529
    }
    .service-text-small{
        color: #4c4d4d
    }
    .service-icon {
        color: #dee3e4;
        transition: color 0.3s ease;
    }
    .hover-section:hover .service-icon {
        color: #28a745;
    }
    .toast-notification {
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0, 0, 0, 0.8);
        color: white;
        padding: 10px 20px;
        border-radius: 5px;
        z-index: 9999;
        opacity: 1;
        transition: opacity 0.3s ease;
    }

    .toast-notification.hide {
        opacity: 0;
        transition: opacity 0.3s ease;
    }
    .notification {
        background: #252C65;
        padding: 20px;
        border-left: 5px solid #252C65;
        border-radius: 5px;
        margin-top: 20px;
    }

    .notification.notice {
        background-color: #d4edda;
        border-color: #029f2f;
    }
    .payment-title {
        margin-bottom: 3px;
        font-weight: 600;
    }
    .ecoCash-logo {
        width: 80px;
        height: auto;
    }
    .notice-text {
        margin: 0 0 15px;
        font-size: 16px;
    }
    .requirements-list {
        list-style: none;
        padding: 0;
        margin: 0 0 15px;
    }
    .requirements-list li {
        display: flex;
        align-items: center;
        font-size: 16px;
        margin-bottom: 5px;
        cursor: pointer;
    }
    .requirement-status {
        margin-right: 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #fff;
    }
    .requirement-label {
        text-decoration: underline;
        transition: color 0.3s ease;
    }
    .requirements-list li:hover .requirement-label {
        color: #28a745;
    }
    .check-icon {
        color: #28a745;
        font-size: 16px;
    }
    .cross-icon {
        color: #dc3545;
        font-size: 16px;
    }
    .button-container .btn-primary {
        background-color: #155724;
        border-color: #155724;
    }
    .button-container .btn-primary:hover {
        background-color: #136d21;
        border-color: #136d21;
    }

</style>
